import reducer from './reducers';
import * as secondAnalysesActions from './actions';
import * as secondAnalysesSelectors from './selectors';

export { secondAnalysesActions, secondAnalysesSelectors };
export default reducer;
